import { css } from '@emotion/react';
import { p2r } from '../../../styles/fonts';
import { breakpoints } from '../../../styles';

const styles = css`
  display: grid;
  grid-row-gap: ${p2r(12)};

  .small-post-list__navigation-link {
    text-decoration: none;
  }

  @media (max-width: ${breakpoints.mobile}px) {
    .small-post-list {
      width: 100%;
      max-width: 344px;
    }
  }
`;

export default styles;
